module.exports = __webpack_public_path__ + "media/images/clearco-invert-bcfb2359acc9e1567d0aab59e5d5f8f9.svg";